import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-co-right-up",
  "use": "icon-co-right-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-corner-right-up\" id=\"icon-co-right-up\"><polyline points=\"10 9 15 4 20 9\" /><path d=\"M4 20h7a4 4 0 0 0 4-4V4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol